<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'

const model = defineModel<boolean>()

function close (): void {
  model.value = false
}
</script>

<template>
  <CustomModalWindow v-model="model" size="large">
    <template #title>
      Обновление в&nbsp;реферальной программе
    </template>

    <p><b>Уважаемые поставщики!</b></p>

    <p>
      Чтобы продаж стало ещё больше, мы усовершенствовали реферальную программу.
      Теперь вы самостоятельно можете настраивать размер скидки для покупателя и&nbsp;кешбэка для специалиста.
      Товары с&nbsp;увеличенной скидкой сделают вас заметнее для покупателей, а&nbsp;товары с&nbsp;увеличенным кешбэком точно заинтересуют специалистов.
      <br><br>
      Воспользуйтесь инструментом и&nbsp;оцените результаты!
    </p>

    <hr class="mb-4">

    <p><b>Инструкция по увеличению процентов</b></p>

    <p>
      1️⃣ Войти в&nbsp;ЛК поставщика.<br><br>
      2️⃣ В&nbsp;разделе «Товары» найти нужный товар и&nbsp;нажать «Изменить».<br><br>
      3️⃣ В&nbsp;карточке товара во&nbsp;вкладке «Основная информация» в&nbsp;секции «Реферальная программа» заполнить поля «Скидка&nbsp;для&nbsp;клиента,&nbsp;%» и&nbsp;«Кешбэк&nbsp;для&nbsp;специалиста,&nbsp;%». Значения по&nbsp;умолчанию равны&nbsp;5%.<br>
      ❗Проценты можно только увеличить.<br><br>
      4️⃣ Нажать «Сохранить изменения». Цена с&nbsp;промокодом (та,&nbsp;что&nbsp;на&nbsp;зелёной плашке) на&nbsp;странице товара и&nbsp;в&nbsp;корзине всегда актуальная, а&nbsp;в&nbsp;поиске и&nbsp;в&nbsp;блоках рекомендаций она обновляется с&nbsp;задержкой до&nbsp;2&nbsp;часов.
    </p>

    <template #action>
      <BasicButton color="green" title="Понятно" @click="close" />
    </template>
  </CustomModalWindow>
</template>
